export default __webpack_public_path__ + "static/media/playstore.fda0003e.png";